import { BrowserRouter as Router, Route, Routes as Switch } from "react-router-dom";
// Components
// Pages
import { Home } from "../pages/home/home";
import { Cursos } from "../pages/Cursos/Cursos";
import { Blog } from "../pages/Blog/Blog";
import { Sobre } from "../pages/Sobre/Sobre";
import { Certificado } from "../pages/Certificado/Certificado";
import { AlunoAprendiz } from "../pages/AlunoAprendiz/AlunoAprendiz";
import MasterClassIA from "../pages/MasterClassIA/MasterClassIA";
import ProjetoCapacita from "../pages/ProjetoCapacita/ProjetoCapacita";
import { ModalProvider } from "../shared/Contexts/Modal.context";
import { ToastProvider } from "../shared/Contexts/Toast.context";


export const Routes = () => {

    return (
        <Router>
            <ToastProvider>
                <ModalProvider>               
                    <Switch>
                        <Route path="/" element={<Home />} />
                        <Route path="/cursos" element={<Cursos />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/sobre" element={<Sobre />} />
                        <Route path="/certificado" element={<Certificado />} />
                        <Route path="/aluno-aprendiz" element={<AlunoAprendiz />} />
                        <Route path="/MasterClassIA" element={<MasterClassIA />} />
                        <Route path="/CapacitaEmpresas" element={<ProjetoCapacita />} />
                    </Switch>                
                </ModalProvider>
            </ToastProvider>
        </Router>

    )
}
